import { useSelector } from "react-redux";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../../helper/utility";
import { Constants } from "../../Common/Constants";
import AreaGraphMonthly from "../../Common/Graphs/AreaGraphMonthyl";
import BarGraph from "../../Common/Graphs/BarGraph";


const Quarterly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const totalWorkouts = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.workouts);
  const totalReps = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.reps);
  const totalWeightsLifted = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.totalWeightLifted);
  const avgSessionDuration = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.avgSessionDuration);
  const totalWorkoutSession = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.duration);
  const caloriesBurnt = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.caloriesBurnt);
  const totalTimeUnderTension = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.timeUnderTension);
  const userStrengthAssessment = useSelector((store) => store.WorkOutAnalyticsReportReducer.strengthAssessmentReport);
  const userGoalGetLeaner = useSelector((store) => store.WorkOutAnalyticsReportReducer.userGoalCountReport.getLeaner);
  const userGoalGetStronger = useSelector((store) => store.WorkOutAnalyticsReportReducer.userGoalCountReport.getStronger);
  const totalWorkoutsCompletedHourly = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutsCompletedHourly.workouts);


  // const sumOfTtotalWorkouts = totalWorkouts.recordcounts.reduce((acc, curr) => acc + curr, 0).toFixed(2);
  const sumOfTtotalWorkouts = sumOfRecordCountsWithoutDecimal(totalWorkouts);
  const sumOfTtotalReps = sumOfRecordCountsWithoutDecimal(totalReps);
  const sumOfTotalWeightsLifted = sumOfRecordCounts(totalWeightsLifted);
  // const sumOfAvgWorkoutSession = sumOfRecordCounts(avgWorkoutSession);
  // const sumOfAvgSessionDuration = sumOfRecordCounts(avgSessionDuration);
  const sumOfTotalWorkoutSession = sumOfRecordCounts(totalWorkoutSession);
  const sumOfcaloriesBurnt = sumOfRecordCounts(caloriesBurnt);
  const sumOfTotalTimeUnderTension = sumOfRecordCounts(totalTimeUnderTension);
  const sumOfUserStrengthAssessment = sumOfRecordCountsWithoutDecimal(userStrengthAssessment);
  const sumOfUserGoalGetLeaner = sumOfRecordCountsWithoutDecimal(userGoalGetLeaner);
  const sumOfUserGoalGetStronger = sumOfRecordCountsWithoutDecimal(userGoalGetStronger);
  const sumOfTotalWorkoutsCompletedHourly = sumOfRecordCountsWithoutDecimal(totalWorkoutsCompletedHourly);


  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.totalWorkoutSession}
          data={totalWorkouts}
          // title={Constants.totalWorkouts}
          title={`${Constants.totalWorkouts} ${sumOfTtotalWorkouts}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.totalReps}
          data={totalReps}
          // title={Constants.totalReps}
          title={`${Constants.totalReps} ${sumOfTtotalReps}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.totalWeighLifted}
          data={totalWeightsLifted}
          // title={Constants.totalWeightLifted}
          title={`${Constants.totalWeightLifted} ${sumOfTotalWeightsLifted}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.avgworkoutsession}
          data={avgSessionDuration}
          // title={Constants.totalWorkoutSessionDuration}
          // title={`${Constants.avgWorkoutSessionDuration} ${sumOfAvgSessionDuration}`}
          title={`${Constants.avgWorkoutSessionDuration}`}

          format=""
          yAxisType='time'
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.avgworkoutsession}
          data={totalWorkoutSession}
          // title={Constants.totalWorkoutSessionDuration}
          title={`${Constants.totalWorkoutSessionDuration} ${secondsToHHMMSS(sumOfTotalWorkoutSession)}`}
          format=""
          yAxisType="time"
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.totalcaloriesBurnt}
          data={caloriesBurnt}
          // title={Constants.caloriesBurnt}
          title={`${Constants.caloriesBurnt} ${sumOfcaloriesBurnt}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.totaltimeUnderTension}
          data={totalTimeUnderTension}
          // title={Constants.timeUnderTension}
          title={`${Constants.timeUnderTension} ${secondsToHHMMSS(sumOfTotalTimeUnderTension)}`}
          format=""
          yAxisType="time"
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.userStrengthAssessment}
          data={userStrengthAssessment}
          // title={Constants.strengthAssessment}
          title={`${Constants.strengthAssessment} ${sumOfUserStrengthAssessment}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.userGoalGetLeaner}
          data={userGoalGetLeaner}
          // title={Constants.getLeaner}
          title={`${Constants.getLeaner} ${sumOfUserGoalGetLeaner}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={workoutanalytics?.userGoalGetStronger}
          data={userGoalGetStronger}
          // title={Constants.getStronger}
          title={`${Constants.getStronger} ${sumOfUserGoalGetStronger}`}
          format=""
        />
      </div>

      <div id="chart" className="col-md-8">
        <BarGraph
          // data={workoutanalytics?.userGoalGetStronger}
          // ttoal hourly wise workouts completed report
          data={totalWorkoutsCompletedHourly}
          // title={Constants.totalWorkoutsCompletedHourly}
          title={`${Constants.totalWorkoutsCompletedHourly} ${sumOfTotalWorkoutsCompletedHourly}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Quarterly;
